import { render, staticRenderFns } from "./PricerPage.vue?vue&type=template&id=254c48cc&scoped=true&"
import script from "./PricerPage.vue?vue&type=script&lang=js&"
export * from "./PricerPage.vue?vue&type=script&lang=js&"
import style0 from "./PricerPage.vue?vue&type=style&index=0&id=254c48cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254c48cc",
  null
  
)

export default component.exports